import React, { useEffect, useState } from "react";
import { useParams } from "react-router";

import axios from "../../axios";
import { apiUrl } from "../../api";
import Header from "../../Layout/Header/Header";
import Controls from "../../Components/Controls/Controls";

const AktuellDetails = (props) => {
  const { id } = useParams();
  const [detaills, setDetaills] = useState({});

  useEffect(() => {
    axios
      .get(`/collections/get/news?filter[_id]=${id.split("-")[1]}`)
      .then((res) => {
        setDetaills(res.data.entries[0]);
      });
  }, [id]);

  return (
    <div>
      <Header small={true} />
    <main>
      <Controls to="/aktuell" date={detaills.date} />
      <img
        style={{ width: "100%" }}
        src={`${apiUrl}/${detaills?.image?.path}`}
        alt="Auto"
      />
      <div dangerouslySetInnerHTML={{ __html: detaills.text }}></div>
    </main>
    </div>
  );
};

export default AktuellDetails;
